import React, { useState, useRef, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import DashboardRouter from "./DashboardRouter";
import LoginScreen from "./LoginScreen";
import { getLoggedInAccessToken, getLoggedInData } from "../common/utils";
import { RootState } from "../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import { setLoginSuccessFully } from "../redux/action";

type PropsFromRedux = ConnectedProps<typeof connector>;
type RouterProps = PropsFromRedux & {};
const Router: React.FC<RouterProps> = ({
  isUserLoggedIn,
  setLoginSuccessFully,
  ...rest
}) => {
  const [tokenLoaded, setTokenLoaded] = useState(false);
  useEffect(() => {
    isUserAvailable();
  }, []);
  const isUserAvailable = async () => {
    const user = await getLoggedInData();
    if (user) {
      setLoginSuccessFully(user);
    }
    setTokenLoaded(true);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        backgroundColor: "white",
      }}
    >
      {tokenLoaded && isUserLoggedIn ? (
        <Routes>
          <Route
            path="/"
            element={isUserLoggedIn ? <DashboardRouter/> : <LoginScreen/>}
          />
          <Route path="/login" element={<LoginScreen/>} />
        </Routes>
      ) : (
        <Routes>
          <Route
            path="/"
            element={isUserLoggedIn ? <DashboardRouter/> : <LoginScreen/>}
          />
        </Routes>
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
});

const connector = connect(mapState, { setLoginSuccessFully });
export default connector(Router);
